import {
  RegExpMatcher,
  TextCensor,
  englishDataset,
  englishRecommendedTransformers,
  randomCharFromSetCensorStrategy,
} from 'obscenity';

const STORAGE_KEY = 'trixel_profanity_filter';
const SYMBOLS = '@#$%&!*';

const matcher = new RegExpMatcher({
  ...englishDataset.build(),
  ...englishRecommendedTransformers,
});

const censor = new TextCensor().setStrategy(randomCharFromSetCensorStrategy(SYMBOLS));

function _applyFilter(text) {
  if (!text || typeof text !== 'string') return text;
  const matches = matcher.getAllMatches(text);
  if (matches.length === 0) return text;
  return censor.applyTo(text, matches);
}

let _enabled = true;
try {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null) _enabled = stored !== 'false';
} catch { /* SSR / no localStorage */ }

const ProfanityFilter = {
  /** Filter text only when the display toggle is enabled. */
  filter(text) {
    return _enabled ? _applyFilter(text) : text;
  },

  /** Always filter text regardless of toggle (for AI-bound messages). */
  filterAlways(text) {
    return _applyFilter(text);
  },

  /** Returns true if the text contains profanity. */
  containsProfanity(text) {
    if (!text || typeof text !== 'string') return false;
    return matcher.hasMatch(text);
  },

  isEnabled() {
    return _enabled;
  },

  setEnabled(val) {
    _enabled = !!val;
    try { localStorage.setItem(STORAGE_KEY, String(_enabled)); } catch {}
  },
};

export default ProfanityFilter;
